import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { FirebaseError } from "firebase/app";
import { auth } from "./firebase";

export const initSentry = (): void => {
  Sentry.init({
    dsn: "https://d1785bcd4334124528876b13faa3b628@o4509033358491648.ingest.us.sentry.io/4509205499805696", // Replace with your actual Sentry DSN
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    environment: "staging",
    // Capture Firebase errors with detailed context
    beforeSend(event) {
      // Add additional context for Firebase errors
      if (event.exception?.values?.[0]?.value?.includes("FirebaseError")) {
        event.tags = {
          ...event.tags,
          firebase_error: "true",
        };
      }
      return event;
    },
  });

  // Set up auth state change listener to track user in Sentry
  auth.onAuthStateChanged((user) => {
    if (user) {
      // Set user context in Sentry when logged in
      Sentry.setUser({
        id: user.uid,
        email: user.email || undefined,
      });
    } else {
      // Clear user context when logged out
      Sentry.setUser(null);
    }
  });
};

// Utility function to capture Firebase errors
export const captureFirebaseError = (
  error: FirebaseError | Error,
  extraContext?: Record<string, any>
): void => {
  if (error instanceof FirebaseError) {
    Sentry.captureException(error, {
      tags: {
        firebase_code: error.code,
        firebase_operation: extraContext?.operation || "unknown",
      },
      extra: extraContext,
    });
  } else {
    Sentry.captureException(error, {
      extra: extraContext,
    });
  }
};
